
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { useContext, useEffect, useState } from 'react';
import { STORAGE_KEYS } from '../../../utils/config';
import environment from '../../../utils/environment';
import { currencyWithNoUnit } from '../../../utils/format';
import { addKeyToImage, chkUrl, imageAlt, setStorage } from '../../../utils/utils';
import AppContext from '../../../store/AppContext';

const Item = ({ item, openSellPopup, openRentPopup, openOrderTrialPopup, setOpenSignUp, setIdOrderTrialPopup, height = "h-full", objectFit = "cover", width = "", index = 0 }: any) => {
    const { windowWidth } = useContext(AppContext);
    const router = useRouter();
    const [images, setImages] = useState(["/asset/image/image-2.png", "/asset/image/customer_1.webp"]);
    const [renderImage, setRenderImage] = useState(item.file && item.file.image_url ? environment.baseImageUrl + addKeyToImage(item.file.image_url, windowWidth, false, (width == ""), (width == "350")) : "/asset/image/No_Image_Available.webp");
    const [host, setHost] = useState("");
    const [onRender, setOnRender] = useState(false);
    const alt_def = imageAlt(item?.file?.alt, item.name);//item?.file?.alt ? item?.file?.alt : item.name;
    const price = (item.purchase_price ? item.purchase_price : item.price);
    const rental_price = (item.rental_price ? item.rental_price : item.rent_price);

    function onMouseUp() {
        setTimeout(() => {
            setOnRender(true);
        }, 500)
    }

    function onMouseOut() {
        setOnRender(false);
        //setRenderImage(images[0]);

    }

    function onCheckAlreadySignUp() {
        let name = localStorage.getItem(STORAGE_KEYS.name);
        let email = localStorage.getItem(STORAGE_KEYS.email);
        let phone = localStorage.getItem(STORAGE_KEYS.phone);
        if (!name || !phone) {
            setIdOrderTrialPopup(item.id);
            setOpenSignUp(true);
            return false
        } else {
            openOrderTrialPopup(item.id)
        }
        return true
    }

    useEffect(() => {
        let index = 0;

    }, [onRender]);

    useEffect(() => {
        setHost(window.location.origin);
    }, [])

    return <div
        key={item.id}
        className='relative w-full flex flex-col'
        onMouseOver={onMouseUp}
        onMouseLeave={onMouseOut}>
        <a
            rel="noopener noreferrer"
            className={width + " " + height + " z-[1] relative flex flex-col lg:flex-col-reverse product_item "}
            title={item.name}
            // href={{ pathname: '/[...group]', query: { group: item?.url?.split("/").filter((e: any) => e !== '') } }}
            href={chkUrl(item?.url)}
        >
            <div className="wrap-img-product">
                <img
                    src={renderImage}
                    alt={alt_def}
                    title={alt_def}
                    width={294}
                    height={381}
                    fetchPriority={(index == 0 ? "high" : "low")}
                    // loading={(index < 2 ? 'eager' : 'lazy')}
                />
            </div>
            <a
                rel="noopener noreferrer"
                title={item.name}
                href={chkUrl(item?.url)}
                onClick={() => {
                    // setStorage(item.id, item.name);
                    // if (setAdditionalId) {

                    //     setAdditionalId(item.id, item.name)
                    // }
                    //router.push(item?.url?.replace(/^\/+/, ''));

                }} className="product_item_bottom p-[8px] h-[104px] md:h-[120px] lg:h-[140px] z-[50]">
                <p className="header_content">{item?.name ?? ""}</p>
                <div className="flex flex-col gap-1 md:gap-2">
                    {
                        item.allowed_sell === true &&
                        <span className={"flex content " + (rental_price ? "" : "hidden")}>
                            <span style={{width: "40px"}}>Thuê:</span>
                            <span className='text-price'>
                                {rental_price ? currencyWithNoUnit(rental_price)+ "/" + item.unit : ""}
                            </span>
                            {item.include_vat ? <b style={{fontSize: "1rem"}}>*</b>: <></>}
                        </span>
                    }
                    <span className={"flex content " + (price ? "" : "hidden")}>
                        <span style={{width: "40px"}}>Bán:</span>
                        <span className='text-price'>
                            {currencyWithNoUnit(price) + "/" + item.unit}
                        </span>
                        {item.include_vat ? <b style={{fontSize: "1rem"}}>*</b>: <></>}
                    </span>
                </div>
            </a>
            {/* <a rel="noopener noreferrer"
                title={item.name}
                href={chkUrl(item?.url)}
                className="flex lg:hidden product_item_bottom p-[8px] lg:p-[16px] h-[104px] md:h-[120px] lg:h-[140px] z-[50]">
                <p className="header_content">{item?.name ?? ""}</p>
                <div className="flex flex-col gap-1 md:gap-2">
                    {
                        item.allowed_sell === true && 
                        <span className={"flex content " + (item?.rent_price ? "" : "hidden")}>
                            <span style={{width: "35px"}}>Thuê:</span>
                            <span className='text-price'>
                                {item?.rent_price ? currencyWithNoUnit(item?.rent_price) + "/" + item.unit : ""}
                            </span>
                            {item.include_vat ? <b className="text-[#FF4D4F] ">*</b>: <></>}
                        </span>
                    }
                    
                    <span className={"flex content " + (price ? "" : "hidden")}>
                        <span style={{width: "35px"}}>Bán:</span> 
                        <span className='text-price'>
                            {currencyWithNoUnit(price) + "/" + item.unit}
                        </span>
                        {item.include_vat ? <b className="text-[#FF4D4F] ">*</b>: <></>}
                    </span>
                </div>
            </a> */}
        </a>

        <Link className="cart hidden lg:flex bottom-6 right-6 absolute z-[3]" rel="noopener noreferrer"
                title={item.name}
                // href={{ pathname: '/[...group]', query: { group: item?.url?.split("/").filter((e: any) => e !== '') } }}
                href={chkUrl(item?.url)}>
            <Image
                priority={true}
                src="/asset/icon/ico_cart.svg"
                alt="Giỏ hàng"
                title='cart'
                className="m-auto"
                width={24}
                height={24}
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
            />
        </Link>
        {/* <div id='product_actions_layout' className='product_actions_layout z-[25] '>
            <button onClick={() => {
                onCheckAlreadySignUp()
            }} className="product_actions">
                <div className='product_actions--circle'>
                    <IconCalendar className={"m-auto ico_action"} />
                </div>
                <p className='text-center'>Đặt lịch thử đồ</p>
            </button>
            <button disabled={item.allowed_sell === false ? true : false} onClick={() => openRentPopup(item.id, item?.is_product, item.url)} className={"product_actions " + (item.allowed_sell === false ? " cursor-not-allowed " : "")}>
                <div className='product_actions--circle'>
                    <IconClock className={"m-auto ico_action"} />
                </div>
                <p className='text-center'>Đặt thuê</p>
            </button>
            <button onClick={() => openSellPopup(item.id, item?.is_product, item.url)} className="product_actions">
                <div className='product_actions--circle'>
                    <IconDollar className={"m-auto ico_action"} />
                </div>
                <p className='text-center'>Đặt mua</p>
            </button>

        </div> */}
        <div className="number_cart z-[2]">
            Mã: {item?.product_code}
        </div>
        {item?.is_sale && <div className="product_sale">
            <Image
                priority={true}
                src={item.file ? environment.baseImageUrl + item?.file.image_url : "/asset/image/product_sale.svg"}
                alt={alt_def}
                title={alt_def}
                className="m-auto"
                width={100}
                height={40}
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
            />
        </div>}
    </div>


}

export default Item;